export const isLoadingSelector = state => state.loader.loading;

export { isLoadingSelector as default };
